import React from "react";
import { Link, useNavigate, useLocation, useSearchParams } from "react-router-dom";

import LogoSecoset from "../../assets/svg/logo-secoset.svg";
import { LoginRight } from "./commons";

const Signup = () => {
  return (
    <div className="flex h-full w-full flex-col bg-white lg:flex-row">
      <div className="mb-6 flex items-center justify-center py-10 lg:w-[50%]">
        <div className="flex w-[360px] flex-col items-center justify-center gap-6 text-center">
          <h1 className="text-xl font-bold text-gray-800">Secoset déménage !</h1>
          <p className="text-gray-600">
            Merci pour votre intérêt pour le Secoset.
            <br />
            Nous avons le plaisir de vous annoncer que le Secoset évolue et s&apos;intègre désormais pleinement à notre nouvelle plateforme <strong>Flying Secoya</strong>.
            <br /><br />
            Pour vous inscrire et découvrir cette nouvelle expérience :
          </p>
          <a
            href="https://app.flyingsecoya.io/register?view=login"
            target="_blank"
            rel="noopener noreferrer"
            className="blue-button w-[280px] text-center"
          >
            Aller sur Flying Secoya
          </a>
          <p className="text-gray-600">À très bientôt sur Flying Secoya !</p>
          <div>
            Déja un compte ?{" "}
            <Link to="/signin" className="cursor-pointer font-bold text-secoset-green-400 hover:underline">
              Connectez-vous
            </Link>
          </div>
        </div>
      </div>
      <LoginRight />
    </div>
  );
};

export default Signup;
